import { Component, AfterViewInit, inject, NgZone, ChangeDetectionStrategy } from "@angular/core";
import { GlobalConfigService } from './../../services/global-config/global-config.service';
import { BroadcastService } from "root/services";




declare global {
  interface Window {
    initMap: () => void;
  }
}

@Component({
  selector: 'mibp-google-maps-script',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class MibpGoogleMapsScriptComponent implements AfterViewInit {
  private globalConfig = inject(GlobalConfigService);
  private broadcastService = inject(BroadcastService);
  private ngZone = inject(NgZone);

  private apiKey: string;
  private currentLang: string;
  private googleScriptTagId = 'google-maps-script';

  constructor() {

    this.apiKey = this.globalConfig.googleMapsScriptKey;
    this.currentLang = this.broadcastService.snapshot.language || 'en';
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => this.loadGoogleMaps());
  }

  private loadGoogleMaps(): void {
    const scriptElm = document.createElement('script');
    scriptElm.id = this.googleScriptTagId;
    scriptElm.setAttribute('type', 'text/javascript');
    scriptElm.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&language=${this.currentLang}&libraries=marker&loading=async&callback=initMap`;
    scriptElm.async = true;
    scriptElm.defer = true;

    window.initMap = () => this.ngZone.run(() => this.initializeMap());

    document.head.appendChild(scriptElm);
  }

  private initializeMap(): void {    
    this.broadcastService.setGoogleMapScriptLoaded(true);
  }
}
